export enum ContractionsPerSecond {
	ZeroToNineTeen = "0",
	TwentyToThirtyNine = "1",
	Forty = "2",
}

export const ContractionsPerSecondMessages = {
	[ContractionsPerSecond.ZeroToNineTeen]: "0-19 seg",
	[ContractionsPerSecond.TwentyToThirtyNine]: "20-39 seg",
	[ContractionsPerSecond.Forty]: "40 seg",
};
